<!--
Author: TangChen
Date: 2018-10-24
Desc: 现金宝收益明细，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-currency-income bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="time-select">
            <span class="demonstration">选择收益时间</span>
            <el-radio-group v-model="tabPosition" class="time-sel-btn">
                <el-radio-button label="1">近一周</el-radio-button>
                <el-radio-button label="2">近一月</el-radio-button>
                <el-radio-button label="3">近三月</el-radio-button>
            </el-radio-group>
        </el-row>
        <chart v-if="chart.xData" :option="chart" :ref-v="'currency-asset'" />
        <el-row class="progress-box">
            <template v-if="showData.length > 0">
                <div
                    v-for="item in showData"
                    :key="item.incomedate"
                    class="progress-list"
                    :style="{ width: item.income / highIncome }"
                >
                    <div class="min-box">
                        <span>{{ item.incomedate }}</span>
                        <span>{{ "+" + item.income }}</span>
                    </div>
                </div>
            </template>
            <div v-if="showData.length === 0" class="no-data">暂无数据</div>
        </el-row>
        <el-row class="page-box">
            <el-pagination
                v-if="tableData.length > conf.PAGE_SIZE"
                :page-size="Number(conf.PAGE_SIZE)"
                background
                layout="prev, pager, next"
                :total="tableData.length"
                v-on:current-change="dataReset"
            />
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import chart from "@/components/misc/chart.vue";
export default {
    name: "CurrencyIncome",
    components: {
        chart
    },
    mixins: [mixin],
    data() {
        return {
            chart: {},
            tableData: [],
            showData: [],
            highIncome: "0",
            tabPosition: "", // 初始化选中按钮值
            conf: {}, // 初始化配置文件内容
            locked: true,
            timePsoi: {} // 自定义时间范围
        };
    },
    watch: {
        // 监听切换时间选择周期
        tabPosition(val) {
            if (val) {
                this.getIncomeData(val);
            }
        }
    },
    mounted() {
        this.tabPosition = "1";
        this.conf = this.$util.getConfig().const;
    },
    methods: {
        // 查询用户收益明细
        getIncomeData(cate) {
            const _this = this;
            let data = {
                filterdatetype: cate,
                pageoffset: "0",
                pagecount: "99"
            };
            this.$util.request("xjb/query/income", data).then((res) => {
                if (res.data) {
                    _this.tableData = res.data;
                    if (_this.tableData.length > 0) {
                        let _obj = [];
                        let _xV = [];
                        for (let i = _this.tableData.length - 1; i >= 0; i--) {
                            _this.highIncome =
                                _this.highIncome > _this.tableData[i].income
                                    ? _this.highIncome
                                    : _this.tableData[i].income;
                            _xV.push(_this.tableData[i].incomedate);
                            _obj.push(_this.tableData[i].income);
                        }
                        _this.chart = {
                            xData: _xV,
                            color: ["#e99400"],
                            name: ["收益明细"],
                            data: [_obj]
                        };
                        if (_this.highIncome <= 0) {
                            _this.highIncome = "1";
                        }
                        _this.dataReset(1);
                    }
                }
            });
        },
        dataReset(val) {
            const _x = this.conf.PAGE_SIZE;
            if (this.tableData.length > _x) {
                this.showData = this.tableData.slice(
                    (val - 1) * _x,
                    this.tableData.length > val * _x ? val * _x : this.tableData.length
                );
            } else {
                this.showData = this.tableData;
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-currency-income {
    .time-select {
        text-align: center;
    }
    .progress-box {
        padding: 10px 25px;
        .progress-list {
            .min-box {
                min-width: 160px;
            }
            border-radius: 4px 4px;
            margin-bottom: 12px;
            background-color: $text-color5;
            height: 28px;
            span {
                line-height: 28px;
                color: $text-color1;
                padding: 0 15px;
                &:last-of-type {
                    float: right;
                }
            }
            &:hover {
                background: var(--color-primary);
                span {
                    color: $text-color5;
                }
            }
        }
        .no-data {
            line-height: 30px;
            text-align: center;
            color: $text-color3;
        }
    }
}
</style>
